const RENDER_VIEW_LENGTH = 4;

const getNodeSlice = node => (
  node.length > RENDER_VIEW_LENGTH
    ? { currentNode: node.slice(0, RENDER_VIEW_LENGTH), nextNode: node.slice(RENDER_VIEW_LENGTH) }
    : { currentNode: node, nextNode: [] }
);

export const createPartiallyRenderer = ({
  isFirstFullLayer = true,
  getNextRenderId,
  renderId,
}) => {
  let isFirstRender = isFirstFullLayer;

  return {
    runRenderLoop({
      onFirstLayerRender,
      onRenderingFinal,
      onLayerRender,
      tree,
    }) {
      if (renderId !== getNextRenderId()) {
        onRenderingFinal();
        return;
      }

      const nextNode = [];

      if (isFirstRender) {
        const nodeSlice = getNodeSlice(tree);
        const t = nodeSlice.currentNode
          .reduce((acc, [nodeKey, node]) => {
            const { currentNode, nextNode: next } = getNodeSlice(node);

            acc[nodeKey] = currentNode;

            if (next.length) {
              nextNode.push([nodeKey, next]);
            }

            return acc;
          }, {});

        if (nodeSlice.nextNode.length) {
          nextNode.push(...nodeSlice.nextNode);
        }

        setTimeout(() => onFirstLayerRender(t), 0);

        isFirstRender = false;

        if (nextNode.length) {
          setTimeout(() => this.runRenderLoop({
            onFirstLayerRender,
            onRenderingFinal,
            getNextRenderId,
            onLayerRender,
            tree: nextNode,
          }), 0);
        } else {
          onRenderingFinal();
        }

        return;
      }

      tree.forEach(([nodeKey, node]) => {
        const { currentNode, nextNode: next } = getNodeSlice(node);

        if (next.length) {
          nextNode.push([nodeKey, next]);
        }

        setTimeout(() => onLayerRender({ nodeKey, currentNode }), 0);
      });

      if (nextNode.length) {
        setTimeout(() => this.runRenderLoop({
          onFirstLayerRender,
          onRenderingFinal,
          getNextRenderId,
          onLayerRender,
          tree: nextNode,
        }), 0);
      } else if (onRenderingFinal) {
        onRenderingFinal();
      }
    },
  };
};
